import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const services = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/services', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  return {list}
}
